import { Photo, Folder, TagColor } from '@/types';

const TAG_COLORS: TagColor[] = ['purple', 'pink', 'blue', 'green', 'orange', 'red', 'yellow', 'teal'];

export function generateAITags(): { tag: string; color: TagColor }[] {
  const tagPool = {
    colors: ['blue', 'warm', 'cool', 'vibrant', 'orange', 'pink', 'monochrome'],
    subjects: ['portrait', 'landscape', 'architecture', 'nature', 'abstract', 'illustration', '3D', 'character'],
    moods: ['minimalist', 'bold', 'elegant', 'modern', 'stylized', 'whimsical'],
    styles: ['procreate', 'midjourney', 'digital art', 'photography'],
    general: ['design', 'creative', 'inspiration', 'prompt'],
  };

  const selectedTags: { tag: string; color: TagColor }[] = [];
  
  // Add 1-2 general tags
  for (let i = 0; i < 1 + Math.floor(Math.random() * 2); i++) {
    const tag = tagPool.general[Math.floor(Math.random() * tagPool.general.length)];
    selectedTags.push({
      tag,
      color: TAG_COLORS[Math.floor(Math.random() * TAG_COLORS.length)]
    });
  }
  
  // Add tags from other categories
  Object.values(tagPool).forEach(tags => {
    if (Math.random() > 0.4) {
      const tag = tags[Math.floor(Math.random() * tags.length)];
      selectedTags.push({
        tag,
        color: TAG_COLORS[Math.floor(Math.random() * TAG_COLORS.length)]
      });
    }
  });
  
  return selectedTags.slice(0, 5 + Math.floor(Math.random() * 3));
}

export function extractColorPalette(): string[] {
  const mockPalettes = [
    ['#3498db', '#2ecc71', '#e74c3c', '#f39c12', '#9b59b6'],
    ['#1abc9c', '#34495e', '#e67e22', '#95a5a6', '#c0392b'],
    ['#16a085', '#27ae60', '#2980b9', '#8e44ad', '#f39c12'],
    ['#ff6b6b', '#4ecdc4', '#45b7d1', '#ffa07a', '#98d8c8'],
    ['#2c3e50', '#e74c3c', '#ecf0f1', '#3498db', '#95a5a6'],
  ];
  
  return mockPalettes[Math.floor(Math.random() * mockPalettes.length)];
}

export function getDefaultFolders(): Folder[] {
  return [];
}

export async function simulateUpload(file: File): Promise<Photo> {
  // Simulate upload delay
  await new Promise(resolve => setTimeout(resolve, 500 + Math.random() * 1000));
  
  const url = URL.createObjectURL(file);
  const tags = generateAITags();
  
  // Get image dimensions
  const dimensions = await new Promise<{ width: number; height: number }>((resolve) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
    img.src = url;
  });

  return {
    id: `photo-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    filename: file.name,
    url,
    tags: tags.map(t => t.tag),
    description: '',
    uploadDate: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    fileSize: file.size,
    fileType: file.type,
    dimensions,
    colors: [], // Will be populated during processing
    rating: 0,
  };
}

export function getTagColor(index: number): TagColor {
  return TAG_COLORS[index % TAG_COLORS.length];
}
